import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import {
    fetchTheftExternal,
    fetchTheftInternal,
} from 'queries/assets-protection/theft/theft'
import { AssetsProtectionTheftProps } from 'types/api'
import { IResponse } from 'utils/api'
import { isStore } from 'utils/location'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { getGreenfieldFilterValues } from 'utils/greenfield'

export function useGetTheftStoreInternal({
    env,
    accessToken,
    location,
}: AssetsProtectionTheftProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const enabled = isStore(location)
    // Theft Internal store-level expects filter key 'store_t_number'
    const filters = getGreenfieldFilterValues('store_t_number', location)

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.THEFT_STORE_GF_INTERNAL, location],
        () =>
            fetchTheftInternal({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            enabled,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}

export function useGetTheftStoreExternal({
    env,
    accessToken,
    location,
}: AssetsProtectionTheftProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const enabled = isStore(location)
    // Theft External store-level expects title-case filter_dimension ("Store")
    const filters = getGreenfieldFilterValues('Store', location)

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.THEFT_STORE_GF_EXTERNAL, location],
        () =>
            fetchTheftExternal({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            enabled,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
